import React from 'react';
import t from '../i18n';

class ViewReference extends React.Component {
  render() {
    const { label } = this.props;
    return (
      <div className="card-reference view one">
        <p>{t('EIXOS COGNITIVOS')}</p>
        <p style={{ textTransform: 'uppercase' }}>{label || 'COMPETÊNCIAS'}</p>
      </div>
    );
  }
}
export default ViewReference;
